// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"9687b713","175":"829602b8","180":"ff7cc5f8","258":"996d492f","260":"6e4879d6","815":"3b6a72d2","948":"2564606f","976":"c5c833c7"}[chunkId] + ".chunk.js";
};